export default __webpack_public_path__ + "static/media/gallery_02.7cd24884.jpg";